import { useParams } from 'react-router-dom';

import { getGameUidFromLocation } from './getGameUidFromLocation';

const useGameUidParam = (): string | null => {
  const { gameUid } = useParams();

  return gameUid ?? getGameUidFromLocation() ?? null;
};

export default useGameUidParam;
